import { render, staticRenderFns } from "./FileChooser.vue?vue&type=template&id=1f24317e&scoped=true&"
import script from "./FileChooser.vue?vue&type=script&lang=ts&"
export * from "./FileChooser.vue?vue&type=script&lang=ts&"
import style0 from "./FileChooser.vue?vue&type=style&index=0&id=1f24317e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f24317e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VMenu})
